import Modal from './Modal';
export default Modal;
import _BaseModal from './BaseModal';
export { _BaseModal as BaseModal };
import _ConfirmModal from './ConfirmModal';
export { _ConfirmModal as ConfirmModal };